import { useEffect, useState } from 'react';
import useAxios from '../../../../hooks/useAxios';
import Constants from '../../../../Constants';
import { DATE_INTERVAL } from '@demandproai/shared';
import { useCompanyFilterContext } from '../../components/context/CompanyFilterContext';

const useSignupCountGraph = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers: tier, selectedStatus: companyStatus, selectedAccountExecutive: accountExecutive } = filterParams;
    const [chartData, setChartData] = useState([]);
    const [interval, setInterval] = useState(DATE_INTERVAL.MONTHLY);
    const [totalSignups, setTotalSignups] = useState(0);

    const { postData, isLoading } = useAxios();

    useEffect(() => {
        const fetchSignupCountGraph = async () => {
            if (!selectedRange?.startDate || !selectedRange?.endDate) {
                console.warn(
                    'selectedRange with startDate and endDate is required for SignupCountGraph'
                );
                return;
            }

            const payload = {
                startDate: selectedRange.startDate.toISOString(),
                endDate: selectedRange.endDate.toISOString(),
                ...(companyStatus?.length > 0 && { status: companyStatus }),
                ...(tier?.length > 0 && { tier }),
                ...(accountExecutive?.length > 0 && { accountExecutive })
            };

            const { success, data } = await postData(
                Constants.ApiUrl.super.dashboard.signupCountGraph,
                payload
            );

            if (success) {
                setChartData(data?.data || []);
                setInterval(data?.interval || DATE_INTERVAL.MONTHLY);
                setTotalSignups(data?.totalSignups || 0);
            }
        };

        fetchSignupCountGraph();
    }, [
        JSON.stringify(companyStatus),
        JSON.stringify(tier),
        JSON.stringify(accountExecutive),
        selectedRange?.startDate?.toISOString(),
        selectedRange?.endDate?.toISOString()
    ]);

    return {
        chartData,
        interval,
        totalSignups,
        isLoading
    };
};

export default useSignupCountGraph;